import { render, staticRenderFns } from "./AsideSettings.vue?vue&type=template&id=6ffefd62"
import script from "./AsideSettings.vue?vue&type=script&lang=js"
export * from "./AsideSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports